import { initialState } from 'store';

export default (state = initialState.collapsed, { type, payload }) => {
  switch (type) {
    case 'COLLAPSED':
      return payload;
    default:
      return state;
  }
};
